import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { CommercialFeature } from '@/types/dtos/commercial-features/commercial-feature.dto';

export const ADMIN_COMMERCIAL_FEATURES_QUERY_KEY = 'admin-commercial-features';

function normalizeFeature(raw: Record<string, unknown>): CommercialFeature {
  const id = String(raw._id ?? raw.id ?? '');
  return {
    id,
    key: String(raw.key ?? ''),
    displayName: String(raw.displayName ?? ''),
    description: raw.description !== undefined && raw.description !== null ? String(raw.description) : undefined,
    allowedScopeTypes: (raw.allowedScopeTypes as CommercialFeature['allowedScopeTypes']) ?? [],
    category: raw.category !== undefined && raw.category !== null ? String(raw.category) : undefined,
    deprecated: Boolean(raw.deprecated),
    replacedByKey:
      raw.replacedByKey !== undefined && raw.replacedByKey !== null ? String(raw.replacedByKey) : undefined,
    createdAt: raw.createdAt ? String(raw.createdAt) : undefined,
    updatedAt: raw.updatedAt ? String(raw.updatedAt) : undefined,
  };
}

export function useAdminCommercialFeaturesQuery() {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [ADMIN_COMMERCIAL_FEATURES_QUERY_KEY],
    queryFn: async () => {
      const token = await getToken();
      const res = (await sendJSONRequest({
        url: `${import.meta.env.VITE_API_URL}/commercial-features/admin`,
        method: METHOD.GET,
        token: token ?? '',
      })) as { features: Record<string, unknown>[] };
      const features = (res.features ?? []).map((f) => normalizeFeature(f));
      return { features };
    },
  });
}
